import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteCustomerAddress } from '../../api/apiStorefront';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useDeleteCustomerAddress = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async (addressId) => {
      const response = await deleteCustomerAddress(addressId);
      return response.data;
    },
    onSuccess: () => {
      toast.success(t('address.deleted', 'Address deleted successfully!'));
      queryClient.invalidateQueries(['customer-addresses']);
    },
    onError: (error) => {
      const message = error.response?.data?.message || t('address.deleteError', 'Failed to delete address');
      toast.error(message);
    },
  });
};
